import { render, staticRenderFns } from "./PosBanner.vue?vue&type=template&id=5ff60c83&scoped=true"
import script from "./PosBanner.vue?vue&type=script&lang=js"
export * from "./PosBanner.vue?vue&type=script&lang=js"
import style0 from "./PosBanner.vue?vue&type=style&index=0&id=5ff60c83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff60c83",
  null
  
)

export default component.exports